import { savePumps } from 'dux/checkoutCart/actions';
import { orderLoadSuccessFromPaymentSuccess } from 'dux/checkoutOrder/actions';
import {
  SET_CARD_PUBKEY,
  SET_PAYMENT_IS_READY,
  SET_STRIPE_TOKEN,
} from 'dux/checkoutPayment/actionTypes';
import { trackPurchaseCompleted } from 'dux/tracking/actions';

import * as OrderService from 'Services/OrderService';

/**
 * Internal store
 */

export const setIsPaymentReady = isPaymentReady => dispatch =>
  dispatch({ type: SET_PAYMENT_IS_READY, isPaymentReady });

/**
 * POST
 */

export const payWithButton = ({ paymentType, saveCard, token }) => async dispatch => {
  try {
    const order = await OrderService.post(token.id, saveCard);
    dispatch(orderLoadSuccessFromPaymentSuccess(order));
    dispatch(
      trackPurchaseCompleted({
        express_checkout: false,
        payment_location: 'cart',
        payment_type: paymentType,
      })
    );
    return { status: 'success', order };
  } catch {
    return { status: 'failure' };
  }
};

export const savePayment = ({ values, stripe, cardElement }) => async dispatch => {
  try {
    await dispatch(savePumps({ values }));

    // This change should be backward compatible, here we introduce logic only if new field is set
    if (values.cardPubkey && values.cardPubkey !== 'newCard') {
      dispatch({ type: SET_CARD_PUBKEY, cardPubkey: values.cardPubkey });
      return { status: 'success' };
    }

    const { token, error } = await stripe.createToken(cardElement, {
      name: values.nameOnCard,
    });

    if (error) {
      return { error, status: 'error' };
    }

    dispatch({
      type: SET_STRIPE_TOKEN,
      token,
    });

    return { status: 'success' };
  } catch {
    return { status: 'failure' };
  }
};
